import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    Content: "",
    props: null,
    title: "",
    subtitle: "",
    closable: false
};

export const dialogSlice = createSlice({
    name: 'dialog',
    initialState: initialState,
    reducers: {
        openDialog: (state, action) => action.payload,
        closeDialog: state => initialState
    }
});

export const {openDialog, closeDialog} = dialogSlice.actions;

export const selectDialog = state => state.dialog;

export default dialogSlice.reducer;
